module.exports = __webpack_public_path__ + "h5/img/2-002.6e69a778.png";